import { type SearchResultCount } from '../../../common/utils/events/dropdown-results-shown';

// todo: update with actual conditional rendering logic
export const conditionalRendering = (
	inputQuery: string,
	count: SearchResultCount,
): SearchResultCount => {
	let { peopleAndTeams, autoSuggestion, recentSearch, recentViews } = count;

	// case 1: pre-query
	let maxDisplayed = {
		peopleAndTeams: 0,
		autoSuggestion: 0,
		recentSearch: 3,
		recentViews: 5,
	};

	// case 2: 1-2 characters in query
	if (inputQuery.length === 1 || inputQuery.length === 2) {
		// with recent search match (same as pre-query)
		if (recentSearch > 0) {
		}
		// with no recent search match, with auto suggestion
		else if (autoSuggestion > 0) {
			maxDisplayed = {
				peopleAndTeams: 0,
				autoSuggestion: 8 - Math.min(5, recentViews),
				recentSearch: 0,
				recentViews: 5,
			};
		}
		// with no recent search match or auto suggestion
		else {
			maxDisplayed = {
				peopleAndTeams: 0,
				autoSuggestion: 0,
				recentSearch: 0,
				recentViews: 7,
			};
		}
	}

	// case 3: 3+ characters in query
	if (inputQuery.length >= 3) {
		// with no person match
		if (peopleAndTeams === 0) {
			// with no person match, with recent search
			if (recentSearch) {
				maxDisplayed = {
					peopleAndTeams: 0,
					autoSuggestion: 3,
					recentSearch: 2,
					recentViews: 3,
				};
			}
			// with no person match or recent search
			else {
				maxDisplayed = {
					peopleAndTeams: 0,
					autoSuggestion: 4,
					recentSearch: 0,
					recentViews: 4,
				};
			}
		}
		// with person match
		else {
			maxDisplayed = {
				peopleAndTeams: 2,
				autoSuggestion: recentSearch > 0 ? 1 : 3, // surface more auto suggestion if no recent search
				recentSearch: 3,
				recentViews: 3,
			};
		}
	}

	return {
		peopleAndTeams: Math.min(maxDisplayed.peopleAndTeams, peopleAndTeams),
		autoSuggestion: Math.min(maxDisplayed.autoSuggestion, autoSuggestion),
		recentSearch: Math.min(maxDisplayed.recentSearch, recentSearch),
		recentViews: Math.min(maxDisplayed.recentViews, recentViews),
	};
};
